import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Locales } from 'shared/assets/localization';
import { setNotificationsOnUser } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

import { queryKey as cacheQueryKey } from './use-cached-push-notification-token-query';

export const useCreatePushNotificationMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, locale }: { userId: ID; locale: Locales }) => {
      await setNotificationsOnUser(userId, locale);
      await client.invalidateQueries({ queryKey: [cacheQueryKey] });
    },
  });
};
